import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: null,
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    updateProfileData: (state, action) => {
        state.data = action.payload
      }
  },
});

const { reducer, actions } = profileSlice;

export const { updateProfileData } = actions
export default reducer;